import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MasterApi,
  PostProductMasterFieldDefRequest,
} from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys as mastersQueryKeys } from '../../api/queryKeys'
import { queryKeys } from './queryKeys'

export const useMutationAddMasterFieldDef = (masterUuid: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (request: PostProductMasterFieldDefRequest) => {
      return await baseClient
        .getApi(MasterApi)
        .addMasterFieldDef({
          masterUuid,
          postProductMasterFieldDefRequest: request,
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.masterFieldDefs(masterUuid),
      })
      queryClient.invalidateQueries({
        queryKey: mastersQueryKeys.master(masterUuid),
      })
      // TODO: 一覧修正時に mastersQueryKeys.products のキーが masterUuid を含む形に変更される予定。その際にここも合わせて修正する。
      queryClient.invalidateQueries({
        queryKey: mastersQueryKeys.products,
      })
    },
  })
}
